import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6c9661aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "animate modal"
}
const _hoisted_3 = { class: "modal-inner" }
const _hoisted_4 = { style: {"font-size":"14px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { style: {"font-size":"14px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  key: 2,
  class: "reputation-container"
}
const _hoisted_12 = { class: "profile" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "animate reputation-card"
}
const _hoisted_16 = { class: "reputation-text" }
const _hoisted_17 = { class: "reputation-line" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Status:", -1))
const _hoisted_19 = { class: "reputation-line" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Puntos:", -1))
const _hoisted_21 = { class: "reputation-line" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Siguiente Nivel:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_24 = {
  key: 3,
  class: "animate table-container"
}
const _hoisted_25 = { class: "modern-table" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", null, "Motivo"),
    /*#__PURE__*/_createElementVNode("th", null, "Puntos ")
  ])
], -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ProfileService from '@/services/ProfileService'
import { ref, onMounted } from 'vue'
import { useAuth } from '@/store/useAuth'
import useWindowWidth from '@/composables/useWindowWidth';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReputationView',
  setup(__props) {

const {windowWidth} = useWindowWidth()
const service = new ProfileService()
const user = ref()
const store = useAuth()
const reputation = ref()
const loading = ref(true)
const logs = ref()
const showAdvice = ref(false)

onMounted(async () => {
    if (!store.token) {
        loading.value = false
        return
    }
    user.value = await service.MyUser(store.token)
    reputation.value = await service.ReputationInfo(store.token)
    logs.value = await service.ReputationLogs(store.token)
    loading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(_unref(main).TITLE_REPUTATIONVIEW), 1),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : _createCommentVNode("", true),
      (showAdvice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                style: {"float":"right","cursor":"pointer"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showAdvice.value = false))
              }, [
                _createVNode(_component_v_icon, {
                  name: "ri-close-circle-fill",
                  fill: "lightcoral"
                })
              ]),
              _createElementVNode("h3", null, _toDisplayString(_unref(main).SUBTITLE_REPUTATIONVIEW), 1),
              _createElementVNode("p", null, [
                _createElementVNode("b", _hoisted_4, _toDisplayString(_unref(main).TEXT_DEFINITION_1), 1),
                _hoisted_5,
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_unref(main).TEXT_DEFINITION_2) + ".", 1)
              ]),
              _hoisted_7,
              _createElementVNode("p", null, _toDisplayString(_unref(main).TEXT_DEFINITION_3), 1),
              _hoisted_8,
              _createElementVNode("p", null, [
                _createElementVNode("b", _hoisted_9, _toDisplayString(_unref(main).TEXT_DEFINITION_4), 1)
              ]),
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(_unref(main).TEXT_DEFINITION_5), 1),
              _createElementVNode("button", {
                class: "new-question",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showAdvice.value = false))
              }, "¡De acuerdo!")
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (user.value.profile_picture_uri)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: user.value.profile_picture_uri
                  }, null, 8, _hoisted_13))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(user.value.name.substring(0, 5)) + "...", 1))
            ]),
            (!loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", {
                    style: {"position":"absolute","right":"5px","top":"5px","cursor":"pointer"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showAdvice.value = true))
                  }, [
                    _createVNode(_component_v_icon, { name: "bi-question-circle-fill" })
                  ]),
                  _createVNode(_component_v_icon, {
                    name: "ri-medal-fill",
                    scale: "7"
                  }),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("h5", null, _toDisplayString(reputation.value.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("h5", null, _toDisplayString(user.value.reputation.toLocaleString()), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("h5", null, _toDisplayString((reputation.value.max_points + 1).toLocaleString()), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_23,
      (!loading.value && logs.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("table", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (log) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: log.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(new Date(log.created_at).getDate()) + "/" + _toDisplayString(new Date(log.created_at).getMonth() + 1) + "/" + _toDisplayString(new
                            Date(log.created_at).getFullYear()), 1),
                    _createElementVNode("td", null, _toDisplayString(log.subject.name), 1),
                    _createElementVNode("td", null, _toDisplayString(log.amount), 1)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})